var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperPlaneTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8215 4.38724C33.8215 4.38724 33.168 4.22006 32.5205 4.40615L32.5154 4.4076L3.40469 12.6067C3.40469 12.6067 2.64278 12.8151 2.13887 13.4233C2.13887 13.4233 1.63495 14.0315 1.57196 14.8189C1.57196 14.8189 1.50897 15.6062 1.90978 16.2868C1.90978 16.2868 2.31059 16.9675 3.01225 17.2862L16.3862 23.6137L22.7057 36.9703C22.7057 36.9703 23.0325 37.6894 23.7131 38.0902C23.7131 38.0902 24.3937 38.491 25.1811 38.428C25.1811 38.428 25.9684 38.365 26.5767 37.8611C26.5767 37.8611 27.1849 37.3572 27.3907 36.6045L35.5903 7.49151C35.5903 7.49151 35.7815 6.83804 35.6127 6.17844C35.6127 6.17844 35.444 5.51883 34.9626 5.03739C34.9626 5.03739 34.4811 4.55596 33.8215 4.38724ZM4.064 15.0182L33.1832 6.81678L24.9843 35.9267L24.9817 35.936L18.6455 22.5435C18.6455 22.5435 18.2692 21.7308 17.4471 21.3501L4.08144 15.0263L4.064 15.0182Z",
    fill: "#5932EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.274 16.4938C25.5084 16.2594 25.6406 15.941 25.6406 15.6094C25.6406 15.2779 25.5089 14.96 25.2745 14.7256L25.2637 14.7149C25.0303 14.4874 24.7165 14.3594 24.3906 14.3594C24.3531 14.3594 24.3156 14.3611 24.2783 14.3645C23.9867 14.3908 23.7137 14.5186 23.5067 14.7256L16.4447 21.7876C16.2103 22.022 16.0781 22.3404 16.0781 22.6719C16.0781 22.692 16.0786 22.712 16.0795 22.732C16.0945 23.0424 16.2245 23.3361 16.4442 23.5558C16.6786 23.7902 16.9966 23.9219 17.3281 23.9219C17.6596 23.9219 17.9776 23.7902 18.212 23.5558L25.274 16.4938Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTilt);
export default __webpack_public_path__ + "static/media/PaperPlaneTilt.5dfcaa46f288e4f750c3dcd7496f33f4.svg";
export { ForwardRef as ReactComponent };